module.exports = __webpack_public_path__ + "8b858007dbab5e598096c6307362908e.png";